import { AssignmentTurnedInOutlined, CheckCircleOutline, EditOutlined } from "@mui/icons-material";
import { Box, IconButton, Stack, SxProps, Typography } from "@mui/material";
import { useState } from "react";
import { ContextPathBreadcrumbs, EditTaskItemContextModal, TaskItemPathBreadcrumbs } from "src/components";
import { TaskItemDetailDto, TaskItemDto } from "src/http";

interface Props {
  taskItem: TaskItemDto | TaskItemDetailDto;
  isEditable: boolean;
  linksOpenDrawer?: boolean;
  sx?: SxProps;
}

const TaskItemContextProperty = (props: Props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", ...props.sx }}>
        {props.taskItem.context ? (
          <AssignmentTurnedInOutlined />
        ) : props.taskItem.parentTaskItem ? (
          <CheckCircleOutline />
        ) : null}

        <Box sx={{ flexGrow: 1, width: "100%" }}>
          {props.taskItem.context ? (
            <ContextPathBreadcrumbs contextPath={props.taskItem.context} linksOpenDrawer={props.linksOpenDrawer} />
          ) : props.taskItem.parentTaskItem ? (
            <TaskItemPathBreadcrumbs
              taskItemParent={props.taskItem.parentTaskItem}
              linksOpenDrawer={props.linksOpenDrawer}
            />
          ) : (
            <Typography variant="placeholder" sx={{ ...props.sx }}>
              Connect to context...
            </Typography>
          )}
        </Box>

        {props.isEditable && (
          <IconButton size="small" sx={{ color: "rgba(0, 0, 0, 0.3)" }} onClick={() => setIsModalVisible(true)}>
            <EditOutlined />
          </IconButton>
        )}
      </Stack>

      {props.isEditable && (
        <EditTaskItemContextModal
          taskItem={props.taskItem}
          open={isModalVisible}
          onDone={() => setIsModalVisible(false)}
          onCancel={() => setIsModalVisible(false)}
        />
      )}
    </>
  );
};

export { TaskItemContextProperty };
